import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "1300px"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.duplicateDigitalTwin')))];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.twinCreateFormValid,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.createCopies
          }
        }, [_c(VIcon, {
          attrs: {
            "left": ""
          }
        }, [_vm._v("fal fa-rocket-launch")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDuplicate')) + "\n    ")], 1)];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "n20-container pb-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "createForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createCopies.apply(null, arguments);
      }
    },
    model: {
      value: _vm.twinCreateFormValid,
      callback: function ($$v) {
        _vm.twinCreateFormValid = $$v;
      },
      expression: "twinCreateFormValid"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pt-2 pb-0 my-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', {
    staticClass: "text-bold"
  }, [_vm._v("\n            " + _vm._s(_vm.orgTwin.title) + "\n            "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.orgTwin.id) + ")")])]), _c('p', {
    staticClass: "card-description"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.copyText')))])])], 1), _vm.orgTwinStates === null ? [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 50,
      "width": 3,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1)], 1)] : [_c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.count'),
      "color": _vm.color,
      "rules": [v => !!v || _vm.$i18n_t('Common.fieldRequired')],
      "outlined": _vm.inpOutlined,
      "max": _vm.maxCopies,
      "filled": _vm.inpFilled,
      "type": "number",
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.copiesCount,
      callback: function ($$v) {
        _vm.copiesCount = $$v;
      },
      expression: "copiesCount"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "6"
    }
  }, [_c(VSelect, {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "outlined": _vm.inpOutlined,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.mode'),
      "items": [{
        value: 'virtualdevices',
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.modeVirtualDevices')
      }, {
        value: 'iothub',
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.modeIotHub')
      }, {
        value: 'complete',
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.modeFull')
      }],
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: _vm.statePickerMode,
      callback: function ($$v) {
        _vm.statePickerMode = $$v;
      },
      expression: "statePickerMode"
    }
  })], 1)], 1), _c(VRow, [_vm.statePickerMode === 'iothub' ? [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12"
    }
  }, [_c('media-file-upload', {
    attrs: {
      "type": 'file',
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.csvUpload'),
      "buttonIcon": 'fal fa-file-csv'
    },
    on: {
      "file": _vm.uploadedFile
    }
  }), _c(VBtn, {
    class: `v-btn-x mx-1 ml-2 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-download")]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvDownload')) + "\n              ")], 1)], 1), !_vm.loadingStates ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-0",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
    staticClass: "text-bold mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.csvUpload')))])]), _c(VExpansionPanelContent, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationSeparator'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationGeoData'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationKeyValue'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationIotHubEui'))
    }
  })])], 1)], 1)], 1) : _vm._e()] : _vm._e(), _vm.statePickerMode === 'virtualdevices' ? [!_vm.loadingStates ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-0",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('p', {
    staticClass: "text-bold mb-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.csvUpload')))])]), _c(VExpansionPanelContent, [_c('h4', [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.downloadHeader', {
    twinTitle: _vm.orgTwin.title
  })) + "\n                    ")]), _c('div', [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.downloadText')) + "\n                    ")]), _c(VBtn, {
    class: `v-btn-x mx-1 ml-2 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_c(VIcon, {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fal fa-download")]), _vm._v("\n                        " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.csv')) + "\n                    ")], 1), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.uploadHeader')))]), _c('div', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.uploadText', {
    twinTitle: _vm.orgTwin.title
  })))]), _c('media-file-upload', {
    attrs: {
      "type": 'file',
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.csvUpload'),
      "buttonIcon": 'fal fa-file-csv'
    },
    on: {
      "file": _vm.uploadedFile
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationSeparator'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationGeoData'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationReferenceIds'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationKeyValue'))
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.copy.sampleCsvExplanationVdeviceId'))
    }
  })], 1)], 1)], 1)], 1) : _vm._e()] : _vm._e()], 2), _c(VRow, {
    staticClass: "mt-2"
  }, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4"
    }
  }, [_c('core-dtwin-finder', {
    style: _vm.globalParentId === false ? 'opacity: 0.5' : '',
    attrs: {
      "objectFilter": _vm.twinParentFilter,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "disabled": _vm.globalParentId === false,
      "required": _vm.globalParentId !== false,
      "tenantId": _vm.orgTwin.tenantId,
      "sameTenant": "",
      "hideDetails": ""
    },
    on: {
      "dtwin-selected": _vm.updateTwinsParents
    },
    model: {
      value: _vm.globalParentId,
      callback: function ($$v) {
        _vm.globalParentId = $$v;
      },
      expression: "globalParentId"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.copy.useGlobalParent'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": e => {
        if (e === true) {
          _vm.globalParentId = _vm.orgTwin.parentId;
        }
      }
    },
    model: {
      value: _vm.globalParentId,
      callback: function ($$v) {
        _vm.globalParentId = $$v;
      },
      expression: "globalParentId"
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "my-0 py-0"
  }, [_c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.tags'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changedDisplayOptions
    },
    model: {
      value: _vm.metaInfoToggles['tags'],
      callback: function ($$v) {
        _vm.$set(_vm.metaInfoToggles, 'tags', $$v);
      },
      expression: "metaInfoToggles['tags']"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.address'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changedDisplayOptions
    },
    model: {
      value: _vm.metaInfoToggles['address'],
      callback: function ($$v) {
        _vm.$set(_vm.metaInfoToggles, 'address', $$v);
      },
      expression: "metaInfoToggles['address']"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.copy.geoCoordinateConfig'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changedDisplayOptions
    },
    model: {
      value: _vm.metaInfoToggles['geocoordinates'],
      callback: function ($$v) {
        _vm.$set(_vm.metaInfoToggles, 'geocoordinates', $$v);
      },
      expression: "metaInfoToggles['geocoordinates']"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.referenceIds.headline'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changedDisplayOptions
    },
    model: {
      value: _vm.metaInfoToggles['referenceIds'],
      callback: function ($$v) {
        _vm.$set(_vm.metaInfoToggles, 'referenceIds', $$v);
      },
      expression: "metaInfoToggles['referenceIds']"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0"
  }, [_c(VSwitch, {
    attrs: {
      "false-value": false,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.keyValue'),
      "inset": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.changedDisplayOptions
    },
    model: {
      value: _vm.metaInfoToggles['keyvalue'],
      callback: function ($$v) {
        _vm.$set(_vm.metaInfoToggles, 'keyvalue', $$v);
      },
      expression: "metaInfoToggles['keyvalue']"
    }
  })], 1)], 1), _vm.statePickerMode !== 'virtualdevices' ? _c('core-dtwin-duplicate-iothub-or-complete', {
    ref: "duplicate-config-form",
    attrs: {
      "orgTwin": _vm.orgTwin,
      "orgTwinStates": _vm.orgTwinStates,
      "twinCopiesData": _vm.twinCopiesData,
      "statePickerMode": _vm.statePickerMode,
      "errornousParentId": _vm.errornousParentId,
      "bridgeConfigs": _vm.bridgeConfigs,
      "globalParentTwin": _vm.globalParentTwin,
      "globalParentId": _vm.globalParentId,
      "loadingStates": _vm.loadingStates,
      "pickableStates": _vm.pickableStates,
      "metaInfoToggles": _vm.metaInfoToggles
    },
    on: {
      "cloneOrgTwinStates": _vm.cloneOrgTwinStates
    }
  }) : _c('core-dtwin-duplicate-virtual-devices', {
    ref: "duplicate-config-form",
    attrs: {
      "orgTwin": _vm.orgTwin,
      "orgTwinStates": _vm.orgTwinStates,
      "twinCopiesData": _vm.twinCopiesData,
      "statePickerMode": _vm.statePickerMode,
      "errornousParentId": _vm.errornousParentId,
      "bridgeConfigs": _vm.bridgeConfigs,
      "globalParentTwin": _vm.globalParentTwin,
      "globalParentId": _vm.globalParentId,
      "loadingStates": _vm.loadingStates,
      "pickableStates": _vm.pickableStates,
      "metaInfoToggles": _vm.metaInfoToggles
    },
    on: {
      "cloneOrgTwinStates": _vm.cloneOrgTwinStates
    }
  })]], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };